import React, { createContext, useContext, useMemo } from 'react';
import { filterItemsConfig } from '../../constants/filter';

const Context = createContext();

export const useFilterItems = (key) => {
  const filterItems = useContext(Context);

  return useMemo(() => {
    if (!key) return filterItems;

    if (Array.isArray(key)) {
      return key.reduce((acc, k) => {
        acc[k] = filterItems[k];
        return acc;
      }, {});
    }

    return filterItems[key];
  }, [key, filterItems]);
};

export const FilterItemsBuilder = ({ data, children }) => {
  const filterItems = useMemo(() => buildFilterItems(data), [data]);

  return <Context.Provider value={filterItems}>{children}</Context.Provider>;
};

function buildFilterItems(data) {
  const baseResult = Object.entries(filterItemsConfig).reduce(
    (acc, [key, { initial }]) => {
      acc[key] = initial
        ? {
            data: initial.data.map((item) => ({ ...item, count: 0 })),
            ids: new Set(initial.ids),
          }
        : { data: [], ids: new Set() };
      return acc;
    },
    {}
  );

  data.forEach((room) => {
    Object.entries(filterItemsConfig).forEach(
      ([key, { getValue, getContent }]) => {
        const { data, ids } = baseResult[key];

        const value = getValue(room);
        if (value == null) return;

        if (ids.has(value)) {
          const item = data.find((i) => i.value === value);
          if (item) item.count += 1;
        } else {
          ids.add(value);
          data.push({ value, content: getContent(room), count: 1 });
        }
      }
    );
  });

  return Object.entries(baseResult).reduce((result, [key, value]) => {
    if (value.ids.size > 0) {
      result[key] = value;
    }
    return result;
  }, {});
}
